// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import myConfig from './config.js'
import myI18n from './components/I18N/i18n.js'
import vuexI18n from 'vuex-i18n'
import Vuex from 'vuex'
import api from './api.js'
import pgStorage from './storage.js'
import 'promise'
import Vuetify from 'vuetify'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'vuetify/dist/vuetify.min.css'
import './main.scss'
import './tables.scss'
// import style (<= Swiper 5.x)
import 'swiper/css/swiper.css'
import './stylus/main.styl'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faStar, faFileExcel} from '@fortawesome/free-solid-svg-icons'
import { faStar as FarStar, faFileExcel as FarExcel } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'
import VueMotion from 'vue-motion'

library.add(faStar,
  FarStar, faFileExcel, FarExcel)


Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)
Vue.use(VueMotion)
Vue.use(VueAwesomeSwiper)
Vue.use(Vuex)
const store = new Vuex.Store()
Vue.use(vuexI18n.plugin, store)
Vue.config.host = myConfig.HOST
Vue.config.data = myConfig
Vue.prototype.$config = myConfig
Vue.prototype.$config.languageId = 1
Vue.prototype.$eventHub = new Vue() // Global event bus
Vue.prototype.$api = api
Vue.prototype.storage = pgStorage
Vue.prototype.storage.init(myConfig)
Vue.credentials = {
  data: {
    user: {
      firstName: '',
      lastName: ''
    }
  }
}
Vue.credentials = null

Vue.config.productionTip = false
Vue.use(myI18n)
// window.jQuery = $
Vue.use(Vuetify, { theme: {
    primary: '#2f5489',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  }}
)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js